module.exports = __webpack_public_path__ + "img/ve.5696caee.svg";